// extracted by mini-css-extract-plugin
export default {"wrapper":"roles_hist_chart-module___wrapper___e138533c","chart":"roles_hist_chart-module___chart___d9b176f2"};